import React, { useMemo, useState } from 'react';
import styles from './ExcelImportWizard.module.scss';
import { Spin } from 'antd';
import { nameTableRows } from '../../../constants/nameTableRso';

import CustomItem from '../../common/CustomItem/CustomItem';
import { useExcelPreviewLoader } from '../../../hooks/useExcelPreviewLoader';
import { useExcelDataLoader } from '../../../hooks/useExcelDataLoader';
import BtnFileBox from '../../common/BtnFileBox/BtnFileBox';

import { useDispatch, useSelector } from 'react-redux';
import { setHighlightedRows } from '../../../store/actions/rsoImportActions';

import useHandleHeaderLineChange from '../../../hooks/useHandleHeaderLineChange';
import useUpdateFile from '../../../hooks/useUpdateFile';

const ExcelImportWizard = ({ form, visible, onClickFetch }) => {
  const { getFieldValue } = form;

  const dispatch = useDispatch();

  const { file, highlightedRows, rowLabels } = useSelector(
    (state) => state.rsoImportStore
  );

  const [isLoading, setIsLoading] = useState(false);
  const [loadingFileUpload, setLoadingFileUpload] = useState(false);

  const handleFileChange = useExcelPreviewLoader(setIsLoading);

  const handleFileUpload = useExcelDataLoader(setLoadingFileUpload);

  const handleHeaderLineChange = useHandleHeaderLineChange(form);

  const updateFile = useUpdateFile(handleFileChange, form);

  const headerLineValue = getFieldValue(nameTableRows.headerRow);
  const dataStartLineValue = getFieldValue(nameTableRows.firstRow);

  const isVisibleBtn = Boolean(headerLineValue && dataStartLineValue);

  const highlightColor = (fieldName) =>
    highlightedRows.find((c) => c.name === fieldName)?.color || '#ffffff';

  const dataStartOptions = useMemo(() => {
    if (!headerLineValue) return rowLabels;
    const headerLineNum = Number(headerLineValue);

    return rowLabels.filter((row) => Number(row.value) > headerLineNum);
  }, [rowLabels, headerLineValue]);

  const clickBtnFile = () => {
    handleFileUpload(headerLineValue, dataStartLineValue);
  };

  const onChangeItem = (fieldName, val) => {
    dispatch(setHighlightedRows(fieldName, val));
  };

  if (!visible) return null;

  return (
    <Spin
      spinning={isLoading}
      tip="Загрузка файла..."
    >
      <div className={styles.root}>
        <BtnFileBox
          updateFile={updateFile}
          loadingFileUpload={loadingFileUpload}
          isVisibleBtn={isVisibleBtn}
          onClick={clickBtnFile}
          onClickFetch={onClickFetch}
        />
        {file && (
          <div className={styles.itemContainer}>
            <CustomItem
              form={form}
              highlightColor={highlightColor}
              options={rowLabels}
              fieldName={nameTableRows.headerRow}
              label="Строка заголовков"
              requiredMessage="Пожалуйста, выберите строку заголовков"
              onChange={(fieldName, val) => {
                if (headerLineValue !== val) {
                  handleHeaderLineChange();
                  onChangeItem(fieldName, val);
                }
              }}
            />

            <CustomItem
              form={form}
              highlightColor={highlightColor}
              options={dataStartOptions}
              fieldName={nameTableRows.firstRow}
              label="Строка начала данных"
              requiredMessage="Пожалуйста, выберите строку начала данных"
              onChange={onChangeItem}
            />
          </div>
        )}
      </div>
    </Spin>
  );
};

export default ExcelImportWizard;
